'use client';

import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

/* eslint-disable @next/next/no-img-element */
import {
  Checkbox,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import { MixpanelEvent } from '@/services/eventEnums';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { MixpanelTracking } from '@/services/mixpanel';
import { useTranslation } from 'react-i18next';

export default function SatelliteImageryScreen({
  setShowContentComponent,
  setOpen,

  userRole,
  setUserRole,
  allSteps,
}: {
  showContentComponent: any;
  dialogFlowRef: any;
  setShowContentComponent: any;
  setOpen: any;
  userRole: any;
  setUserRole: any;
  allSteps: any;
}) {
  const { t } = useTranslation('orderImagery');
  const userRolesOptions = [
    {
      label: 'Executive / Decision Maker',
      value: 'Executive / Decision Maker',
      tKey: 'urExecutive',
    },
    {
      label: 'Data Analyst / Researcher',
      value: 'Data Analyst / Researcher',
      tKey: 'urDataAnalyst',
    },
    {
      label: 'Developer / Technical',
      value: 'Developer / Technical',
      tKey: 'urDeveloper',
    },
    {
      label: 'Other',
      value: 'Other',
      tKey: 'urOther',
    },
  ];
  const handleCheckBoxClick = (value: any) => {
    setUserRole(value);
    setShowContentComponent(allSteps['form']);
    MixpanelTracking.getInstance().track(MixpanelEvent.EXPLORE_MOBILE_INTRO_ROLE_CLICK, {
      role: value,
    });
    MixpanelTracking.getInstance().track(MixpanelEvent.EXPLORE_MOBILE_INTRO_FORM_OPEN);
  };

  return (
    <>
      <IconButton
        name="back"
        aria-label="close-delete-item-dialog"
        className="close-btn"
        onClick={() => {
          setShowContentComponent(allSteps['main']);
        }}
        sx={{
          position: 'absolute',
          top: 5,
          left: 8,
        }}
      >
        <ArrowBackOutlinedIcon />
      </IconButton>
      <DialogTitle
        sx={{ margin: '1rem 0px 0px 0px', p: '2', textAlign: 'center' }}
        id="customized-dialog-title"
      >
        {t('describeRole', 'What best describe your role?')}
      </DialogTitle>
      <IconButton
        name="Close Delete Item"
        aria-label="close-delete-item-dialog"
        className="close-btn"
        onClick={() => {
          setOpen(false);
          MixpanelTracking.getInstance().track(MixpanelEvent.EXPLORE_MOBILE_INTRO_DIALOG_CLOSE);
        }}
        sx={{
          position: 'absolute',
          right: 8,
          top: 5,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        className="mbl-intro-dialog-content"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <List component="nav" className="mbl-intro-content-list">
          {userRolesOptions?.map((item: any, index: any) => {
            return (
              <ListItem key={index} className="mble-intro-role-item">
                <ListItemButton
                  className="mbl-intro-content-btn"
                  sx={{ '&:hover': { backgroundColor: '#314158' } }}
                  onClick={() => {
                    handleCheckBoxClick(item?.value);
                  }}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={userRole === item?.value}
                      // tabIndex={-1}
                      onClick={() => {
                        handleCheckBoxClick(item?.value);
                      }}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText id={item?.label} primary={t(item?.tKey)} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
    </>
  );
}
